import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider, AudioProvider } from './contexts';
import { ProtectedRoute, MiniAudioPlayer } from './components';
import { Landing, Login, Dashboard, TeacherDashboard, StudentDashboard, ContentPlayer, SchoolDiscovery, ComingSoon, About, Contact, CurriculumBrowser, AuthVerify, SetPassword } from './pages';
import { trackPageView } from './utils/analytics';
import './App.css';

// Track page views on route changes
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  
  return null;
}

function AppContent() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set initial document direction based on language
    const lang = i18n.language;
    document.documentElement.dir = lang === 'fa' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    document.body.lang = lang;
  }, [i18n.language]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route path="/auth/setup" element={<SetPassword />} />
      <Route path="/register" element={<ComingSoon />} />
      <Route path="/schools" element={<SchoolDiscovery />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/teacher"
        element={
          <ProtectedRoute allowedRoles={['teacher', 'admin']}>
            <TeacherDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/student"
        element={
          <ProtectedRoute allowedRoles={['student', 'admin']}>
            <StudentDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/player/:id"
        element={
          <ProtectedRoute>
            <ContentPlayer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/curriculum"
        element={
          <ProtectedRoute allowedRoles={['student', 'admin']}>
            <CurriculumBrowser />
          </ProtectedRoute>
        }
      />
      {/* Future routes will be added here */}
      <Route path="/tablets/:id" element={<ComingSoon />} />
      <Route path="/:type/:id" element={<ComingSoon />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<ComingSoon />} />
      <Route path="/terms" element={<ComingSoon />} />
      <Route path="*" element={<ComingSoon />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AudioProvider>
          <PageTracker />
          <AppContent />
          <MiniAudioPlayer />
        </AudioProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
